import React, { useContext } from "react";
import { formatMonth } from "./helpers/date";
import Context from "./EventsProvider";
import styled from "@emotion/styled";
import DropDownContainer from "./DropdownContainer";
import Calendar from "./Calendar";
import { useMediaQuery } from "react-responsive";

import { Colors, Sizes } from "../../styles";



const EventsHeader = () => {
	const { data: { language, params } } = useContext(Context);
	
	const isDesktopOrLaptop = useMediaQuery({
		query: `(min-width: ${Sizes.screens.large})`,
	});

	const getMonthName = () => {
		if (!params) return;

		if (params.month) {
			const [month, year] = params.month.split('-');
			const date = new Date(`${month}/01/${year}`);
			return formatMonth(date, language).full;
		}

		if (params.date) {
			const [day, month, year] = params.date.split('-');
			const date = new Date(`${month}/${day}/${year}`);
			return `${formatMonth(date, language).full} ${day}, ${year}`;
		}
	}

	const title = () => {
		if (language === 'fr') return "Au programme: ";
		return "What's on: ";
	}

	const renderMobileCalendar = () => {
		if (!isDesktopOrLaptop) {
			return (
				<MobileCalendarContainer>
					<Calendar />
				</MobileCalendarContainer>
			);
		}
	}

	return (
		<Header>
			{ renderMobileCalendar() }
			<GridTitle>{ title() }<span>{ getMonthName() }</span></GridTitle>
			<DropDownContainer />
		</Header>
	)
};

export default EventsHeader;

const Header = styled.header`
	display: grid;
	grid-template-columns: 1fr;
	row-gap: 4rem;
`;

const GridTitle = styled.h2`
	margin-bottom: 3rem;
	color: ${Colors.grey.charcoal};
	font-size: 2.6rem;
	line-height: 2.7rem;
	letter-spacing: -0.005em;
	order: 3;
	margin-top: 2rem;

@media only screen and (min-width: ${Sizes.screens.large}) {
		margin-bottom: unset;
		margin-top: unset;
		font-size: 3rem;
		line-height: 3.4rem;
		letter-spacing: -0.005em;	
		order: unset;
	}

	span {
		display: inline-block;
		
		&:first-letter {
			text-transform: uppercase;
		}
	}
`;

const MobileCalendarContainer = styled.div`
	order: 1;
	justify-self: center;

	@media only screen and (min-width: ${Sizes.screens.large}) {
		order: unset;
	}
`;
